export default __webpack_public_path__ + "static/media/bannerBg.687097e8.png";